import React from 'react';
import './SignIn.css';
import {auth, googleProvider} from './base'

const SignIn = () => {
    const authenticateGoogle = () => {
        auth.signInWithPopup(googleProvider)
    }
    return(
        <div className="SignIn">
            <h1>BoilerFaves</h1>
            <h2>Know when your faves are available!</h2>
            <button className="SignIn"
                onClick={authenticateGoogle}
            >
            <a><i class="fa fa-google" aria-hidden="true"></i>Sign In With Google</a>
            </button>
        </div>
    )
}

export default SignIn


// WEBPACK FOOTER //
// ./src/SignIn.js